module.exports = __webpack_public_path__ + "img/plex-mono-dark.20b89851.png";